import Boleto25BlackBG from '@/components/organisms/Boleto25BlackBG';
import Boleto25Stack from '@/components/organisms/Boleto25Stack';
import Boleto25Video from '@/components/organisms/Boleto25Video';
import DenFraudesBoletoSeguro from '@/components/organisms/DenFraudesBoletoSeguro';
import DenFraudesBoletoVerdadeiro from '@/components/organisms/DenFraudesBoletoVerdadeiro';
import DenFraudesGolpe from '@/components/organisms/DenFraudesGolpe';
import { useEffect, useState } from 'react';
import Head from 'next/head';
import React from 'react';
import Styles from './DenFraudes.css';
import DenFraudesMudancaRazaoSocial from '@/components/organisms/DenFraudesMudancaRazaoSocial';

// function useWindowSize() {
//   const [size, setSize] = useState({ width: 0, mobile: false });

//   useEffect(() => {
//     if (typeof window === 'undefined') return; // Evita erro no SSR

//     function handleResize() {
//       setSize({ width: window.innerWidth, mobile: window.innerWidth <= 768 });
//     }

//     // Define tamanho inicial
//     handleResize();

//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   return size;
// }

function DenFraudes({ onTabChanged }) {
  return (
    <>
      <Head>
        <title>Denúncias e fraudes | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Fique atento às fraudes de boleto e outros tipos. Entenda quais são as principais informações que você precisa saber para evitar cair em golpes."
        />

        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/denuncias-e-fraudes.html"
        />

        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Denúncias e fraudes | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/denuncias-e-fraudes.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Fique atento às fraudes de boleto e outros tipos. Entenda quais são as principais informações que você precisa saber para evitar cair em golpes."
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/denuncias-e-fraudes/img-golpe.png"
        />
        <meta
          property="og:image:alt"
          content="Casal pesquisando sobre como detectar um golpe no site da Santander Financiamentos."
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="article" />
        <meta property="article:author" content="" />
        <meta property="article:section" content="" />
        <meta property="article:tag" content="" />
        <meta property="article:published_time" content="1900-01-00" />

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="Denúncias e fraudes | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="Fique atento às fraudes de boleto e outros tipos. Entenda quais são as principais informações que você precisa saber para evitar cair em golpes."
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/denuncias-e-fraudes.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/denuncias-e-fraudes/img-golpe.png"
        />
        <meta
          property="twitter:image:alt"
          content="Casal pesquisando sobre como detectar um golpe no site da Santander Financiamentos."
        />
        <meta property="twitter:image:type" content="image/png" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <DenFraudesBoletoVerdadeiro />
      <DenFraudesMudancaRazaoSocial />
      <DenFraudesGolpe />
      <DenFraudesBoletoSeguro />

      <style jsx>{Styles}</style>
    </>
  );
}

export default DenFraudes;
